













































































import { Component, Vue } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';

import { MigrationUser } from '@/common/MIgration';

import Staff from '@/services/Staff';

import Welcome from '@/components/Global/Welcome.vue';
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';

@Component({
	name: 'StaffMigrations',
	components: {
		Alert,
		Loading,
		Welcome,
	},
})
export default class StaffMigrations extends Vue {
	private loading: boolean = true;
	private error: boolean = false;
	private migrations: MigrationUser[] = [];
	private paginate: string[] = ['setupMigration'];
	private search: string = '';
	private showMigrated: boolean = false;

	get setupMigration() {
		let migrations = this.migrations;
		if (this.showMigrated) {
			migrations = migrations.filter(m => m.migratestatus === 'migrated');
		}

		if (this.search !== '') {
			const regex = new RegExp(this.search, 'gi');
			migrations = migrations.filter(
				m =>
					(m.mmicusername && m.mmicusername.match(regex)) ||
					(m.email && m.email.match(regex)) ||
					(m.firstname && m.firstname.match(regex)) ||
					(m.lastname && m.lastname.match(regex)),
			);
		}

		return migrations;
	}

	private loadUser(accountid) {
		this.$router.push({
			name: 'staffmigrationuser',
			params: {
				accountId: accountid,
			},
		});
	}

	private async created() {
		Staff.getMigrations()
			.then(({ data }: AxiosResponse) => {
				console.log(data);
				this.migrations = data;
				this.loading = false;
			})
			.catch(e => {
				console.log(e);
				this.error = true;
			});
	}
}
